import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-aurea-typo",
  templateUrl: "./aurea-typo.component.html",
  styleUrls: ["./aurea-typo.component.scss"],
})
export class AureaTypoComponent {
  colours = [
    {
      swatch: "#e63916",
      title: "Chili red",
      code: "#e63916",
    },
    {
      swatch: "#1a1508",
      title: "Smoky black",
      code: "#1a1508",
    },
    {
      swatch: "#eaeae9",
      title: "Smoky black",
      code: "#eaeae9",
    },
  ];

  constructor() {}
}
